import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'
Vue.use(Router)

export default new Router({
  routes: [
    // 默认选择主题页面
    {
      path: '/',
      redirect: 'index'
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta: { keepAlive: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js